export default __webpack_public_path__ + "static/media/arow-down.649758e6.svg";